import 'css-chunksrc/client/scenes/zoneCreation/styles.scss';export default {
  "group": "_group_7hguc_1",
  "text": "_text_7hguc_5",
  "name": "_name_7hguc_10",
  "main": "_main_7hguc_16",
  "buttons": "_buttons_7hguc_23"
};